module.exports = __webpack_public_path__ + "img/5.2928142c.jpg";